//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import faqIndexQuery from '~/apollo/queries/faq/faq-index'
import faqTopicsQuery from '~/apollo/queries/faq/faq-topics'

export default {
  mixins: [seo],
  apollo: {
    faqIndex: {
      query: faqIndexQuery,
      prefetch: true
    },
    faqTopics: {
      query: faqTopicsQuery,
      prefetch: true
    }
  },
  created () {
    this.seoTitle = 'FAQ'
  }
}

